import {
  EMPLOYEE_DATA_START,
  EMPLOYEE_DATA_ERROR,
  EMPLOYEE_DATA_SUCCESS,
  CLICKED_GRADE,
  SET_GRADE_INDEX_RANGE,
  GRADE_TITLE_SUCCESS,
  VIEW_GRADE_SAVE_STATE,
  JOBS_IN_GRADE_SET_TEXT,
  JOBS_IN_GRADE_SET_CURRENT_TAB,
  BACK_TO_LIST
} from '../actions/ViewGradeActions';
import { SMA_RESET_ERRORS } from '../actions/GradeListActions';
import { HIDE_SLIDEOUT } from 'ps-components/Slideout/SlideoutReducer';

export const GRADE_TABS = {
  GRADE_DETAILS: 0,
  GRADE_JOBS: 1
};

export const initialState = {
  gradeTitle: '',
  currentTab: GRADE_TABS.GRADE_DETAILS,
  employeeData: [],
  employeeCount: 0,
  employeeLoading: false,
  employeeError: null,
  maxGradeIdx: null,
  modelId: null,
  offset: 0,
  state: null,
  searchText: null,
  clickedGrade: {
    prevGrade: null,
    nextGrade: null,
    current: {
      min: 0,
      mid: 0,
      max: 0
    },
    proposed: {
      min: 0,
      mid: 0,
      max: 0
    },
    totals: {
      jobCount: {
        current: 0,
        proposed: 0
      },
      employeeCount: {
        current: 0,
        proposed: 0
      },
      belowMin: {
        current: 0,
        proposed: 0
      },
      aboveMax: {
        current: 0,
        proposed: 0
      },
      costToMin: {
        current: 0,
        proposed: 0
      }
    }
  }
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case HIDE_SLIDEOUT:
      return {
        ...initialState
      };
    case GRADE_TITLE_SUCCESS:
      return {
        ...state,
        gradeTitle: action.title
      };
    case EMPLOYEE_DATA_START:
      return {
        ...state,
        employeeLoading: true,
        employeeError: null
      };
    case EMPLOYEE_DATA_ERROR:
      return {
        ...state,
        employeeLoading: false,
        employeeError: true
      };
    case SMA_RESET_ERRORS:
      return {
        ...state,
        employeeError: null
      };
    case EMPLOYEE_DATA_SUCCESS:
      return {
        ...state,
        employeeData: action.payload.data.result.result,
        employeeCount: action.payload.data.result.total,
        offset: action.payload.offset,
        employeeLoading: false,
        employeeError: false
      };
    case SET_GRADE_INDEX_RANGE:
      return {
        ...state,
        maxGradeIdx: action.maxGradeIdx
      };
    case CLICKED_GRADE:
      return {
        ...state,
        modelId: action.modelId,
        currentTab: action.payload.p_job_count > 0 ? state.currentTab : GRADE_TABS.GRADE_DETAILS,
        clickedGrade: {
          prevGrade: state.maxGradeIdx !== undefined && action.prevGradeIdx < 0 ? null : action.prevGradeIdx,
          nextGrade:
            state.maxGradeIdx !== undefined && action.nextGradeIdx > state.maxGradeIdx ? null : action.nextGradeIdx,
          current: {
            min: action.payload.c_minimum,
            mid: action.payload.c_midpoint,
            max: action.payload.c_maximum
          },
          proposed: {
            min: action.payload.p_minimum,
            mid: action.payload.p_midpoint,
            max: action.payload.p_maximum
          },
          avg: action.payload.avg ? action.payload.avg : null,
          totals: {
            jobCount: {
              current: action.payload.c_job_count,
              proposed: action.payload.p_job_count
            },
            employeeCount: {
              current: action.payload.c_ee_count,
              proposed: action.payload.p_ee_count
            },
            belowMin: {
              current: action.payload.c_below_min,
              proposed: action.payload.p_below_min
            },
            aboveMax: {
              current: action.payload.c_above_max,
              proposed: action.payload.p_above_max
            },
            costToMin: {
              current: action.payload.c_cost_to_move_min,
              proposed: action.payload.p_cost_to_move_min
            }
          }
        }
      };
    case VIEW_GRADE_SAVE_STATE:
      return {
        ...state,
        state: action.payload
      };
    case JOBS_IN_GRADE_SET_TEXT:
      return {
        ...state,
        searchText: action.payload
      };
    case JOBS_IN_GRADE_SET_CURRENT_TAB:
      return {
        ...state,
        currentTab: action.payload
      };
    case BACK_TO_LIST:
      return {
        ...state,
        currentTab: GRADE_TABS.GRADE_DETAILS
      };
    default:
      return state;
  }
}
